import { __assign } from 'tslib';
import React from 'react';
import cn from 'classnames';
import { hasOwnProperty, isNonNullable, devWarning } from '../../shared/esm';
import { useId } from '@alfalab/hooks';

var defaultColors = {"component":"spinner__component_o3db7"};
require('./default.css');

var styles = {"spinner":"spinner__spinner_8iidr","spin_animation":"spinner__spin_animation_8iidr","visible":"spinner__visible_8iidr","gradient":"spinner__gradient_8iidr"};
require('./index.css');

var invertedColors = {"component":"spinner__component_hjana"};
require('./inverted.css');

var presetStyles = {"preset16":"spinner__preset16_xdo1k","preset24":"spinner__preset24_xdo1k","preset48":"spinner__preset48_xdo1k"};
require('./preset.css');

var colorStyles = {
    default: defaultColors,
    inverted: invertedColors,
};
var PRESET_CONFIG = {
    16: [2, 14, 'preset16'],
    24: [2, 20, 'preset24'],
    48: [4, 40, 'preset48'],
};
var Spinner = function (props) {
    var _a;
    var style = props.style, visible = props.visible, id = props.id, className = props.className, dataTestId = props.dataTestId, _b = props.colors, colors = _b === void 0 ? 'default' : _b;
    var size;
    var lineWidth;
    var presetClassname;
    if (hasOwnProperty(props, 'preset')) {
        var preset = props.preset;
        var config = PRESET_CONFIG[preset];
        var styleKey = config[2];
        lineWidth = config[0], size = config[1];
        presetClassname = presetStyles[styleKey];
    }
    else {
        size = props.size;
        lineWidth = props.lineWidth;
    }
    var color = style === null || style === void 0 ? void 0 : style.color;
    if (isNonNullable(color)) {
        devWarning("[Spinner]: \u041F\u0430\u043B\u0438\u0442\u0440\u0430, \u0432 \u043A\u043E\u043D\u0442\u0435\u043A\u0441\u0442\u0435 \u043A\u043E\u0442\u043E\u0440\u043E\u0439 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0435\u0442\u0441\u044F \u0441\u043F\u0438\u043D\u043D\u0435\u0440 (\u043F\u0440\u043E\u043F 'colors') \u0438\u0433\u043D\u043E\u0440\u0438\u0440\u0443\u0435\u0442\u0441\u044F. \u0418\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0435\u0442\u0441\u044F \u0446\u0432\u0435\u0442 'style.color' ".concat(color));
    }
    var uniqId = useId();
    var radius = size / 2 - lineWidth / 2;
    var rotationAngle /* deg */ = Math.ceil((Math.asin(lineWidth / 2 / radius) * 180) / Math.PI);
    var gap /* deg */ = 90;
    var pathLength /* deg */ = 360;
    var strokeDasharray = "".concat(pathLength - gap - rotationAngle, " ").concat(gap + rotationAngle);
    var gradient = "conic-gradient(from ".concat(rotationAngle, "deg, transparent ").concat(gap - rotationAngle * 2, "deg, currentColor)");
    return (React.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', viewBox: "0 0 ".concat(size, " ").concat(size), style: __assign(__assign({}, style), { height: size, width: size }), className: cn(styles.spinner, colorStyles[colors].component, presetClassname, className, (_a = {}, _a[styles.visible] = visible, _a)), "data-test-id": dataTestId, id: id },
        React.createElement("defs", null,
            React.createElement("mask", { id: uniqId },
                React.createElement("circle", { cx: '50%', cy: '50%', r: radius, strokeWidth: lineWidth, strokeLinecap: 'round', stroke: '#fff', strokeDashoffset: -rotationAngle, strokeDasharray: strokeDasharray, pathLength: pathLength }))),
        React.createElement("foreignObject", { x: '0', y: '0', width: size, height: size, mask: "url(#".concat(uniqId, ")") },
            React.createElement("div", { className: styles.gradient, style: { backgroundImage: gradient } }))));
};

export { Spinner };
